/******/ (function() { // webpackBootstrap
var __webpack_exports__ = {};
class FaqSearch extends HTMLElement {
  constructor() {
    super();
    this.searchInput = document.querySelector('.faq-search-input');
    this.nbResults = document.querySelector('.faq-nb-results');
    this.faqSearchContainer = document.querySelector('.faq-search-container');
    this.faqItems = document.querySelectorAll('accordion-tab');
    this.searchButton = document.querySelector('.faq-search-button');
    this.clearButton = document.querySelector('.faq-clear-button');
    this.faqSection = document.getElementById('faq');
    this.buttonBackFaq = document.querySelector('.faq-list-button');
    this.currentResults = [];
    this.currentSearchTerm = '';
    this.searchInput.addEventListener('input', e => {
      const searchTerm = e.target.value.toLowerCase().trim();
      this.currentSearchTerm = searchTerm;
      if (this.searchInput.value == '' && !this.clearButton.classList.contains('hidden')) {
        this.faqSearchContainer.classList.remove('input-field__filled');
      }
      if (searchTerm.length < 2) {
        this.currentResults;
        if (this.faqSection.classList.contains('faq--with-results')) {
          this.faqSection.classList.remove('faq--with-results');
          this.initFaqItems();
        }
        return;
      }
      const results = [];
      this.faqItems.forEach(item => {
        const question = item.querySelector('.accordion__heading-text')?.textContent.toLowerCase();
        const answer = item.querySelector('.accordion__content')?.textContent.toLowerCase();
        if (question?.includes(searchTerm) || answer?.includes(searchTerm)) {
          results.push({
            item: item,
            question: question,
            answer: answer
          });
        }
      });
      this.currentResults = results;
    });
    this.searchButton?.addEventListener('click', () => {
      this.faqItems.forEach(item => {
        item.removeAttribute('highlighted');
      });
      if (this.currentSearchTerm.length >= 2) {
        this.displayResults(this.currentResults, this.currentSearchTerm);
      }
    });
    this.searchInput?.addEventListener('keypress', e => {
      this.faqItems.forEach(item => {
        item.removeAttribute('highlighted');
      });
      if (e.key === 'Enter' && this.currentSearchTerm.length >= 2) {
        this.displayResults(this.currentResults, this.currentSearchTerm);
      }
    });
    this.clearButton?.addEventListener('click', () => {
      this.searchInput.value = '';
      this.faqSearchContainer.classList.remove('input-field__filled');
      this.faqSection.classList.remove('faq--with-results');
      this.initFaqItems();
    });
    this.buttonBackFaq?.addEventListener('click', () => {
      this.faqSearchContainer.classList.remove('input-field__filled');
      this.faqSection.classList.remove('faq--with-results');
      this.searchInput.value = '';
      this.currentResults = [];
      this.currentSearchTerm = '';
      this.initFaqItems();
    });
  }
  showElement(el) {
    el.classList.remove('hidden');
  }
  hideElement(el) {
    el.classList.add('hidden');
  }
  initFaqItems() {
    this.faqItems.forEach(item => {
      item.removeAttribute('highlighted');
      item.querySelector('.accordion__panel').setAttribute('hidden', '');
      item.querySelector('.accordion__toggle').setAttribute('aria-expanded', 'false');
    });
  }
  displayResults(results, searchTerm) {
    const showResults = results.map(result => {
      result.item.setAttribute('highlighted', '');
    });
    this.faqSearchContainer.classList.add('input-field__filled');
    this.faqSection.classList.add('faq--with-results');
    if (results.length === 0) {
      this.nbResults.querySelector('p').textContent = `${theme.searchStrings.noResult}`;
    } else {
      this.nbResults.querySelector('p').textContent = `${results.length} ${theme.searchStrings.resultsFor}  "${searchTerm}" `;
    }
  }
}
customElements.define('faq-search', FaqSearch);
/******/ })()
;